export default __webpack_public_path__ + "images/models/d0ca0ee50e661b057c521fa63a43a72e.glb";